import React, {useEffect} from 'react';


import {PersonalBox} from "../personal-box/Personal-box";
import {InfoCard} from "components/pages/personal-cabinet/personal-profile/profile-info/info-student/Info-card";
import {Notification} from "entities/Profile/model/types/profile";
import {
    LessonsItemDemo
} from "components/pages/groups/online-communication/lessons-demo/main-table-demo/lessons-item-demo/LessonsItemDemo";
import {useAppDispatch, useAppSelector} from "common/hook";
import {fetchLessonsDemo} from "features/model/service/lessons/lessons-demo/fetchLessonsDemo";
import {CustomPagination} from "components/pagination/CustomPagination";
import {getProfileData} from "entities/Profile/model/selectors/getProfileData/getProfileData";


export const PersonalCabinetDemoStudent = () => {
    const data = useAppSelector(getProfileData)


    const paginationData = useAppSelector((state) => state.lessonsDemo.pagination);

    const dispatch = useAppDispatch()
    const {page, pageSize, pageCount} = paginationData;

    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(fetchLessonsDemo({page: value - 1}));
    };

    useEffect(() => {
        dispatch(fetchLessonsDemo({}));
    }, [dispatch]);

    return (
        <div className="tabs-content">
            <div className="tab">
                <PersonalBox/>
                <InfoCard notifications={data?.notifications}/>
                <div className='tabs-content-title'>Запишитесь на демо-занятие</div>
                <div className="data-tbl inner-group-lesson-tbl data-tbl-padding">
                    <div className="row thead">
                        <div className="col lesson-col">Занятие</div>
                        <div className="col status-col">Статус</div>
                        <div className="col lesson-time-col">Время занятия</div>
                        <div className="col btn-col"></div>
                    </div>
                    <LessonsItemDemo/>
                    {pageCount > 1 && (
                        <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle}/>
                    )}
                </div>
            </div>
        </div>
    );
};

